import React, { useEffect, useState, useRef } from "react";
import baseURL from "../url";
import "./Banners.css";

export default function Banners() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    const [index, setIndex] = useState(0);
    const intervalRef = useRef(null);
    const pauseRef = useRef(false);

    useEffect(() => {
        cargarBanners();
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`)
            .then((res) => res.json())
            .then((data) => {
                const arr = data.banner.map((b) => b.imagen);
                setImages(arr);
                setLoading(false);
            })
            .catch((error) => console.error("Error al cargar banners:", error));
    };

    // Autoplay estable
    useEffect(() => {
        if (images.length === 0) return;

        intervalRef.current = setInterval(() => {
            if (!pauseRef.current) {
                setIndex((prev) => (prev + 1) % images.length);
            }
        }, 3000);

        return () => clearInterval(intervalRef.current);
    }, [images.length]);

    // Pausar autoplay en interacción
    const pauseAutoplay = () => {
        pauseRef.current = true;
        setTimeout(() => (pauseRef.current = false), 4000);
    };

    const next = () => {
        pauseAutoplay();
        setIndex((prev) => (prev + 1) % images.length);
    };

    const prev = () => {
        pauseAutoplay();
        setIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    if (loading) return <div className="loadingBanner"></div>;
    if (images.length === 0) return null;

    return (
        <div style={styles.container}>
            {/* Imagen */}
            <div style={styles.imageWrapper}>
                <img
                    src={images[index]}
                    alt={`banner-${index}`}
                    style={styles.image}
                    onClick={pauseAutoplay}
                />
            </div>

            {/* Flecha izquierda */}
            <button style={{ ...styles.arrow, left: "15px" }} onClick={prev}>
                ‹
            </button>

            {/* Flecha derecha */}
            <button style={{ ...styles.arrow, right: "15px" }} onClick={next}>
                ›
            </button>

            {/* Indicadores */}
            <div style={styles.dots}>
                {images.map((_, i) => (
                    <div
                        key={i}
                        onClick={() => {
                            pauseAutoplay();
                            setIndex(i);
                        }}
                        style={{
                            ...styles.dot,
                            backgroundColor: index === i ? "#fff" : "rgba(255,255,255,0.5)",
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

const styles = {
    container: {
        position: "relative",
        width: "80%",
        margin: "0 auto",
        overflow: "hidden",
        borderRadius: "20px",
    },
    imageWrapper: {
        width: "100%",
        height: "280px",
        borderRadius: "20px",
        overflow: "hidden",
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        objectPosition: "center",   
        display: "block",
        borderRadius: "20px",
        margin: "0 auto",          
    },
    arrow: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "40px",
        height: "40px",
        background: "rgba(0,0,0,0.4)",
        borderRadius: "50%",
        fontSize: "24px",
        color: "#fff",
        border: "none",
        cursor: "pointer",
        zIndex: 20,
    },
    dots: {
        display: "flex",
        gap: "6px",
        position: "absolute",
        bottom: "12px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 20,
    },
    dot: {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        cursor: "pointer",
        transition: "0.3s",
    },
};
